<template>
  <div>
    <b-table bordered hover small
             ref="CriteriaTable"
             :items="items"
             :fields="headers"
             responsive >

      <template slot="caption" slot-scope="option">
        <span v-if="'Số lần được sử dụng' === option.value">
          {{ option.value }}
          <i :class="sortIconClass"></i>
        </span>
        <template v-else>{{option.value}}</template>
      </template>

      <template slot="[]" slot-scope="data">
        <span v-html="data.value"></span>
      </template>

    </b-table>
    <b-button-toolbar class="mt-2">
      <b-form-group label="Xắp xếp">
        <b-form-radio-group
          id="btn-radios-1"
          v-model="order"
          :options="options"
          name="sortCriteria"
          size="sm"
          buttons
        ></b-form-radio-group>
      </b-form-group>
    </b-button-toolbar>
  </div>
</template>

<script>
import staticFields from "@/utils/fields";

export default {
  name: 'CriteriaUsageTable',

  data() {
    return {
      headers: [],
      items: [],
      order: "normal",
      stickyStyle: {
        position: "sticky",
        left: "0",
        background: "white",
        zIndex: 1
      },
      options: [
        { text: 'Tăng dần', value: 'asc' },
        { text: 'Giảm dần', value: 'desc' },
        { text: 'Theo thứ tự', value: 'normal'},
      ]
    };
  },
  created() {
    this.init()
  },
  computed: {
    sortIconClass() {
      return this.order === 'normal' ? 'fa fa-arrow-normal' : this.order === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down';
    }
  },
  watch: {
    order(nVal,oVal) {
      this.toggleSortOrder()
    }
  },

  methods: {
    init() {
      let header = []
      header.push({key: 'caption', label: 'Số Thứ tự hiển thị', thStyle: {minWidth: "160px"} ,stickyColumn: true})
      let item0 = {caption: 'Tần suất / Tiêu chí'}
      let item1 = {caption: 'Số lần được sử dụng'}

      if (staticFields) {
        for (const staticField of staticFields) {
          if (staticField?.order && staticField?.label) {
            let index = parseInt(staticField.order)
            if (index <= 97) {
              header.push({
                key: `${staticField.key}`,
                label: staticField.order,
                thStyle: staticField.thStyle || {minWidth: "155px", textAlign: "center", fontSize: "12px"},
                thClass: "text-muted"
              })

              item0 = {
                ...item0,
                [staticField.key]: staticField.label,
                align: "center",
                tdStyle: {textAlign: "center"}
              }
              item1 = {
                ...item1,
                [staticField.order]: 0,
                align: "center",
                tdStyle: {textAlign: "center"}
              }
            }

          }

        }
        this.headers = header
        this.items = []
        this.items.push(item0)
        this.items.push(item1)
      }
      this.getData()
    },
    async getData() {
      try {
        let params = {}
        const {data} = await this.$axios.get(this.$configs.api
          + `/api/v4/filters/calculatePoints?sort=count&order=${this.order}`, {params});
        if (data) {
          let item = {caption: 'Số lần được sử dụng',stickyColumn: true}
          for (const datum of data) {
            item = {
              ...item,
              [datum.key]: datum.count,
              align: "center",
              tdStyle: {textAlign: "center"}
            }
          }
          // Xóa dòng cuối cùng
          this.items.pop();

          // Thêm item mới vào mảng, đảm bảo reactivity
          this.items.push(item);

          this.$refs.CriteriaTable.refresh();

        }
      } catch (e) {
        console.log(e)
      }
    },
    async toggleSortOrder() {

      const order = this.order
      if ('normal' === order) {
        this.init()
        return
      }
      try {
        let params = {}
        const {data} = await this.$axios.get(this.$configs.api
          + `/api/v4/filters/calculatePoints?sort=count&order=${order}`, {params});
        if (data) {
          let header = []
          header.push({key: 'caption', label: 'Số Thứ tự hiển thị', thStyle: {minWidth: "160px"}, stickyColumn: true})
          let item0 = {caption: 'Tần suất / Tiêu chí'}

          let item1 = {caption: 'Số lần được sử dụng', stickyColumn: true}
          for (const datum of data) {
            let staticField = staticFields.find(item => item.key === datum.key)

            item1 = {
              ...item1,
              [datum.key]: datum.count,
              align: "center",
              tdStyle: {textAlign: "center"}
            }
            if (staticField && parseInt(staticField.order) <=97) {
              header.push({
                  key: datum.key,
                  label: staticField.order,
                  thStyle: staticField.thStyle || {minWidth: "155px", textAlign: "center", fontSize: "12px"},
                  thClass: "text-muted",
                }
              )
              item0 = {
                ...item0,
                [staticField.key]: staticField.label,
                align: "center",
                tdStyle: {textAlign: "center"}
              }
            }


          }

          this.headers = header
          this.items = []
          this.items.push(item0)
          this.items.push(item1)
          this.$refs.CriteriaTable.refresh();
        }
      } catch (e) {
        console.log(e)
      }

    },

  }
};
</script>
<style scoped>
.summary p {
  margin-bottom: 0.5rem;
}

table {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}

/* Custom scrollbar styling */
.table-responsive::-webkit-scrollbar {
  height: 8px;
}

.table-responsive::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background-color: #999;
}
</style>
